<template>
  <div class="min-h-screen bg-gray-900 p-4 md:p-6 rounded-2xl">
    <div class="glass-card rounded-2xl p-1 mb-2">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <div class="flex items-center gap-2">
            <v-img
                src="/img/icons/soroosh.png"
                max-height="80"
                max-width="80"
            ></v-img>
            <span class="text-sm text-gray-400"> : POWERED BY</span>
            <div class="w-4 h-4 mb-1 bg-green-400 rounded-full animate-pulse"></div>

          </div>
        </div>
        <button @click="updateBalance" style="max-width: 100px"
                class="px-4 mr-2 ml-3 py-2 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg text-white text-sm font-semibold hover:opacity-90 transition-opacity flex items-center gap-2">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
          </svg>
          بروزرسانی
        </button>
      </div>
    </div>
    <div class="mb-6">
      <div
          class="glass-card rounded-2xl p-1 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div class="flex items-center gap-4">
          <div class="relative">
            <div
                class="w-16 mr-6 h-16 rounded-xl bg-gradient-to-br from-purple-600 to-pink-500 flex items-center justify-center shadow-lg">
              <span class="text-2xl font-bold text-white">{{ user.first_name.charAt(0) }}</span>
            </div>
            <div
                class="absolute -bottom-1 -right-1 w-6 mr-6 h-6 bg-green-500 rounded-full border-2 border-gray-900 flex items-center justify-center">
              <svg class="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"/>
              </svg>
            </div>
          </div>
          <div>
            <h1 class="text-2xl font-bold text-white mb-1">
              <span class="bg-gradient-to-r from-purple-400 via-pink-400 to-orange-400 bg-clip-text text-transparent">
                {{ user.first_name }}
              </span>
              <span class="text-gray-300 mr-2">خوش آمدید</span>
            </h1>
            <div class="flex items-center gap-2 mt-2">
              <div class="relative">
                <div
                    class="w-8 h-8 rounded-full bg-gradient-to-r from-green-500/20 to-emerald-600/20 flex items-center justify-center">
                  <svg class="w-5 h-5 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                          d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"/>
                  </svg>
                </div>
                <div class="absolute -top-1 -right-1 w-3 h-3 bg-green-400 rounded-full animate-ping"></div>
              </div>
              <span class="text-gray-400 text-sm">سطح دسترسی:</span>
              <span
                  class="px-3 py-1 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full text-xs font-semibold text-white shadow-lg">
                مدیر کل
              </span>
            </div>
          </div>
        </div>
        <div class="bank-card rounded-2xl p-6 border-l-4 border-l-purple-500">
          <div class="flex items-center justify-between mb-4">

            <div>
              <p class="text-gray-400 text-sm mb-1">موجودی کیف پول کاربران</p>
              <p class="text-3xl font-bold text-white">
                {{ balance | toMoney }}
                <span class="text-sm text-gray-400 mr-1">تومان</span>
              </p>
            </div>
            <div
                class="w-12 h-12 mr-6 rounded-xl bg-gradient-to-br from-purple-500/20 to-pink-500/20 flex items-center justify-center">
              <svg class="w-7 h-7 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"/>
              </svg>
            </div>
          </div>
          <div class="pt-4 border-t border-gray-700/50">
            <div class="flex items-center text-sm text-gray-400">
              <svg class="w-4 h-4 ml-1 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd"
                      d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z"
                      clip-rule="evenodd"/>
              </svg>
              <span>آخرین بروزرسانی: {{ new Date().toLocaleTimeString('fa-IR') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <inventory-report-mini-card></inventory-report-mini-card>

    <div class="space-y-6 mt-5">
      <orders-total class=" rounded-2xl overflow-hidden"/>
      <shop-orders-list-table class="glass-card rounded-2xl overflow-hidden"/>
    </div>
  </div>
</template>

<script>
import ShopOrdersListTable from "@/modules/order_admin/ShopOrdersList";
import OrdersTotal from "@/modules/order_admin/OrdersTotal";
import InventoryReportMiniCard from "@/modules/report/InventoryCurrencyMiniCard";

export default {
  name: "ManagerDashboard",
  components: {InventoryReportMiniCard, OrdersTotal, ShopOrdersListTable},
  data() {
    return {
      balance: 0,
    };
  },
  mounted() {
    this.updateBalance()
  },
  methods: {
    updateBalance() {
      this.request({
        url: this.endpoint('finance/walletsBalanceSum'),
        method: "get",
        success: data => {
          this.balance = data.total_balance
        }
      })
    },
  }
};
</script>

<style scoped>

.glass-card {
  background: rgba(2, 6, 23, 0.55);
  backdrop-filter: blur(22px);
  -webkit-backdrop-filter: blur(22px);
  border: 1px solid rgba(255, 255, 255, 0.10);
  box-shadow:
      0 20px 60px rgba(0, 0, 0, 0.55),
      inset 0 1px 0 rgba(255, 255, 255, 0.06);
  isolation: isolate; /* اضافه کردن این خط */
}
.bank-card {
  background: rgba(2, 6, 23, 0.55);
  backdrop-filter: blur(22px);
  -webkit-backdrop-filter: blur(22px);
  border: 1px solid rgba(255, 255, 255, 0.10);
  position: relative;
}

.glass-card::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
      radial-gradient(circle at 18% 12%, rgba(255,255,255,0.08), transparent 45%),
      linear-gradient(to bottom, rgba(255,255,255,0.06), transparent 35%);
}

.glass-card > * {
  position: relative;
  z-index: 1;
}

::-webkit-scrollbar { width: 8px; }
::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 999px;
}
::-webkit-scrollbar-thumb {
  background: linear-gradient(
      to bottom,
      rgba(52, 211, 153, 0.7),
      rgba(99, 102, 241, 0.7)
  );
  border-radius: 999px;
}
</style>